import React from 'react';
import RolePrivateRoute from 'src/components/PrivateRotes/RolePrivateRoute';
import TerminationAuditListView from './components/TerminationAuditListView';
import { ACCOUNTING_TERMINATION_AUDIT_CONFIG } from './config';

const AccountingTerminationAuditPage = () => (
  <TerminationAuditListView config={ACCOUNTING_TERMINATION_AUDIT_CONFIG} />
);

const AccountingTerminationAuditView = () => {
  return (
    <>
      <RolePrivateRoute component={AccountingTerminationAuditPage} />
    </>
  );
};

export default AccountingTerminationAuditView;
